module.exports = __webpack_public_path__ + "static/media/bill-grey.d176c93c.svg";